export enum GlobalErrorActionTypes {
    SET_ERROR = 'SET_ERROR',
    CLEAR_ERROR = 'CLEAR_ERROR',
}

export type GlobalErrorState = {
    message: string | null;
}

export interface SetGlobalErrorAction {
  type: GlobalErrorActionTypes.SET_ERROR
  payload: string
}

export interface ClearGlobalErrorAction {
    type: GlobalErrorActionTypes.CLEAR_ERROR
}

export type GlobalErrorActions = SetGlobalErrorAction | ClearGlobalErrorAction;